import { BaseMapper } from '@ps/utils';
import { SurveyLocationGroup } from '@ps/survey-utils';

import { LocationGroupDto } from '../dtos/location-group.dto';

export class LocationGroupMapper extends BaseMapper<
  LocationGroupDto,
  SurveyLocationGroup
> {
  public fromDto(dto: LocationGroupDto): SurveyLocationGroup {
    return {
      groupName: dto.group_name,
      conditionCodes: dto.condition_codes,
    };
  }
}
